import Backbone from 'backbone';

var Mobel_Session_Recording_Rule = Backbone.Model.extend({
    defaults: {
        account_id  : 0,
        rule_type   : '', // block, ignore, mask
        selector    : ''
    }
});

export default Mobel_Session_Recording_Rule;